module.exports = __webpack_public_path__ + "assets/media/convo.e50da4b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/convo.png
// module id = 3237
// module chunks = 0